import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import {onMounted, withDefaults, onBeforeUnmount, shallowRef} from 'vue';
import LivePlayerControl from 'v-component/smart/live-player-control.vue';
import {createTCPlayer} from 'common/tcplayer';
import {PlayerEventTypeEnum} from 'common/enum';
import throttle from 'lodash.throttle';


export default /*#__PURE__*/_defineComponent({
  props: {
    id: { default: 1 },
    live: { type: Boolean, default: false },
    url: null,
    poster: null
  },
  emits: ['click-play'],
  setup(__props: any, { emit }) {

const props = __props as { id: number | string, live: boolean, url: string, poster: string }





let destroyEffectFns = null;

const playerId = `tc-player-${props.id}`;

let player = null; // TcPlayer实例

const duration = shallowRef(0);
const currentTime = shallowRef(0);
const isPlaying = shallowRef(false);

function playerListener(tcPlayer) {
    tcPlayer.on(PlayerEventTypeEnum.LOADEDMETADATA, () => {
        duration.value = player.duration();
    });

    tcPlayer.on(PlayerEventTypeEnum.TIMEUPDATE, () => {
        currentTime.value = player.currentTime();
    });

    tcPlayer.on(PlayerEventTypeEnum.PLAY, () => {
        isPlaying.value = true;
    });

    tcPlayer.on(PlayerEventTypeEnum.PAUSE, () => {
        isPlaying.value = false;
    });

    tcPlayer.on(PlayerEventTypeEnum.ENDED, () => {
        isPlaying.value = false;
    });
}

function initPlayer() {
    player = createTCPlayer(playerId, {
        url: props.url,
        poster: props.poster,
        hlsConfig: {
            videoType: props.live ? 'LIVE' : 'VOD'
        }
    });

    playerListener(player);

    const resizeEvent = throttle(() => {
        if (!player) {
            return;
        }
        const documentWidth = document.documentElement.clientWidth,
            documentHeight = document.documentElement.clientHeight;

        player.width(documentWidth);
        player.height(documentHeight);
    }, 100);
    window.addEventListener('resize', resizeEvent);
    destroyEffectFns = destroyEffectFns || [];
    destroyEffectFns.push(
        () => {
            if (player) {
                player.dispose();
            }
        },
        () => window.removeEventListener('resize', resizeEvent)
    );
}

const clickPlay = () => {
    if (!player) {
        return;
    }
    emit('click-play');
    if (isPlaying.value) {
        player.pause();
    } else {
        player.play();
    }
};

onMounted(initPlayer);

onBeforeUnmount(() => {
    if (destroyEffectFns) {
        destroyEffectFns.forEach(fn => fn());
        destroyEffectFns = null;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isPlaying) && __props.live)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: "live-player-popup icon-play-live",
          onClick: clickPlay
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("video", {
      id: playerId,
      class: "tc-player",
      preload: "auto",
      playsinline: "",
      "webkit-playsinline": "",
      "x5-playsinline": ""
    }),
    (!__props.live)
      ? (_openBlock(), _createBlock(LivePlayerControl, _mergeProps({
          key: 1,
          duration: _unref(duration),
          "current-time": _unref(currentTime),
          "is-playing": _unref(isPlaying)
        }, _ctx.$attrs, { onClickPlay: clickPlay }), null, 16 /* FULL_PROPS */, ["duration", "current-time", "is-playing"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})